module.exports = __webpack_public_path__ + "fonts/UpheavalPro.fe7a6c07.ttf";